module.exports = __webpack_public_path__ + "static/gp-qr-code-2-fa911690d7a0aee41da211508383c330.png";